import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");

const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchDoctorOpdBillItemRouters = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS,
) => {
  return axiosInstance.get(EndPoints.DOCTOR_OPD_BILL_ITEM.LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter,
    },
  });
};

export const fetchDoctorOpdBillItemDetail = (appointment_id) => {
  const url = EndPoints.DOCTOR_OPD_BILL_ITEM.DETAIL + `/${appointment_id}`;

  return axiosInstance.get(url);
};

export const fetchDoctorOpdBillItemDropdown = (payload) => {
  return axiosInstance.get(EndPoints.DOCTOR_OPD_BILL_ITEM.DROPDOWN, payload);
};

export const createDoctorOpdBillItem = (payload) => {
  return axiosInstance.post(EndPoints.DOCTOR_OPD_BILL_ITEM.CREATE, payload);
};

export const updateDoctorOpdBillItem = (payload) => {
  return axiosInstance.put(EndPoints.DOCTOR_OPD_BILL_ITEM.UPDATE, payload);
};

export const deleteDoctorOpdBillItem = (payload) => {
  const url = EndPoints.DOCTOR_OPD_BILL_ITEM.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};

export const downloadDoctorOpdBillItemCSV = () => {
  return axiosInstance.put(
    EndPoints.DOCTOR_OPD_BILL_ITEM.DOWNLOAD_CSV,
    {},
    {
      responseType: "blob",
    },
  );
};
